// 统一请求路径前缀在libs/axios.js中修改
import { getRequest, postRequest } from '@/libs/axios';

// 分页获取消息信息
export const _getByPage = (params) => {
    return getRequest('/powerUser/getByPage', params)
};

//添加或修改权利人
export const _add = (params) => {
    return postRequest('/powerUser/add', params)
};

